import { Languages, X } from "lucide-react";
import { useLang } from "@/i18n/LanguageProvider";

/**
 * Subtle banner shown when the visitor's browser language differs from the
 * current page language (and they haven't yet picked one). Suggests the
 * switch but never auto-changes – the user keeps control.
 */
export const LanguageHint = () => {
    const { hintNeeded, setLang, dismissHint } = useLang();

    if (!hintNeeded) return null;

    const messages = {
        en: {
            title: "This page is also available in English.",
            cta: "Switch to English",
            dismiss: "Stay in German",
        },
        de: {
            title: "Diese Seite ist auch auf Deutsch verfügbar.",
            cta: "Auf Deutsch wechseln",
            dismiss: "In English bleiben",
        },
    };
    const m = messages[hintNeeded];
    if (!m) return null;

    return (
        <div
            className="fixed top-28 right-5 z-[60] max-w-sm bg-ink text-white shadow-2xl border-l-2 border-brand-500 p-4 sm:p-5 animate-fade-in"
            role="dialog"
            aria-label="Language suggestion"
            data-testid="language-hint"
        >
            <div className="flex items-start gap-2.5">
                <Languages size={16} className="text-clay-300 shrink-0 mt-0.5" />
                <p className="font-body text-xs text-white/85 leading-relaxed flex-1">
                    {m.title}
                </p>
                <button
                    onClick={dismissHint}
                    className="text-white/60 hover:text-white shrink-0"
                    aria-label="Close"
                    data-testid="language-hint-close"
                >
                    <X size={14} />
                </button>
            </div>
            <div className="flex gap-2 mt-3">
                <button
                    onClick={dismissHint}
                    className="flex-1 inline-flex items-center justify-center px-3 py-1.5 border border-white/25 text-white/85 hover:bg-white/5 hover:border-white text-xs font-body font-medium tracking-wide transition-colors"
                    data-testid="language-hint-stay"
                >
                    {m.dismiss}
                </button>
                <button
                    onClick={() => setLang(hintNeeded)}
                    className="flex-1 inline-flex items-center justify-center px-3 py-1.5 bg-brand-500 hover:bg-brand-600 text-white text-xs font-body font-medium tracking-wide transition-colors"
                    data-testid="language-hint-switch"
                >
                    {m.cta}
                </button>
            </div>
        </div>
    );
};
